import { MaterialIcon } from '../MaterialIcon';

interface BlackCardProps {
  text: string;
  className?: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function BlackCard({ text, className = '', label = 'DECK AFTER DARK', size = 'md' }: BlackCardProps) {
  const sizeClasses =
    size === 'sm'
      ? 'w-48 h-64 md:w-56 md:h-72 p-6'
      : size === 'lg'
        ? 'aspect-[3/4] p-8'
        : 'w-64 h-80 p-stack-md';

  return (
    <div
      className={`relative bg-black border border-white/20 rounded-xl text-left card-shadow text-white flex flex-col justify-between ${sizeClasses} ${className}`}
    >
      <p className="font-card-text text-card-text leading-snug min-h-0 overflow-y-auto break-words whitespace-pre-wrap">{text}</p>
      <div className="flex items-center gap-2 opacity-70 shrink-0 pt-3">
        <MaterialIcon name="playing_cards" className="text-[16px]" filled />
        <span className="text-[10px] font-bold tracking-widest uppercase">{label}</span>
      </div>
    </div>
  );
}
